/* TD UX-COLL 2026-10-11 — design idea #19 (Felix 11.10.2026): start screen of the search drawer
   (snippets/td-ux-coll-search-start.liquid).
   - The start screen is visible while the search field is empty and hidden as soon as there is text
     (Prestige empties the results slot when the field is cleared, so both never show at the same time).
   - A suggestion chip fills the field and fires an input event → Prestige's predictive search runs as if typed.
     Ctrl/Cmd/Shift/middle click keep the normal link to the search results page. */
(function () {
  if (window.tdUxCollSearchInit) return;
  window.tdUxCollSearchInit = true;

  function parts(el) {
    var root = el.closest('header-search') || document;
    return {
      start: root.querySelector('[data-td-search-start]'),
      input: root.querySelector('input[name="q"]')
    };
  }

  function sync(input) {
    var p = parts(input);
    if (p.start) p.start.hidden = input.value.trim() !== '';
  }

  document.addEventListener('input', function (event) {
    var t = event.target;
    if (t && t.matches && t.matches('header-search input[name="q"]')) sync(t);
  });

  document.addEventListener('reset', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('header-search')) return;
    setTimeout(function () {
      var input = form.querySelector('input[name="q"]');
      if (input) sync(input);
    }, 0);
  }, true);

  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-td-search-start] [data-td-q]');
    if (!chip || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var p = parts(chip);
    if (!p.input) return;
    event.preventDefault();
    p.input.value = chip.getAttribute('data-td-q');
    p.input.dispatchEvent(new Event('input', { bubbles: true }));
    p.input.focus();
  });

  // The field can be pre-filled (browser back/forward cache): hide the start screen then
  document.querySelectorAll('header-search input[name="q"]').forEach(sync);
})();
